export const DOCUMENTS_NAMES = {
  PEP: {
    name: 'agreementPEP',
    label: 'pep-agreement',
  },
  PersonalData: {
    name: 'agreementProc',
    label: 'pep-sopd',
  },
  BKI: {
    name: 'agreementBKI',
    label: 'pep-bki',
  },
};

export const AGREEMENT_DOCUMENTS_TYPES = {
  [DOCUMENTS_NAMES.PEP.label]: {
    name: 'Соглашение об использовании простой электронной подписи',
    type: 'electronic-document',
  },
  [DOCUMENTS_NAMES.PersonalData.label]: {
    name: 'Согласие на обработку персональных данных',
    type: 'personal-data',
  },
  [DOCUMENTS_NAMES.BKI.label]: {
    name: 'Согласие на взаимодействие с бюро кредитных историй',
    type: 'credit-history-data',
  },
};

export const SMS_VERIFICATION_PROVIDER = {
  TELEPONY: 'TELEPONY',
  ECREDIT_SMS: 'ECREDIT_SMS',
};

export const TELEPONY_NOTIFICATION = {
  title: 'Пробуем новый способ подписания согласия',
  description:
    'Некоторые клиенты уже могут самостоятельно подписать согласие — для этого они должны отправить код обратным СМС. Вы сможете следить за статусом подписания',
};

export const PROCESS_INFO_STATES = {
  awaiting: 'awaitingState',
  wrongCode: 'wrongCodeState',
  globalTimeout: 'globalTimeoutState',
};

export const PROCESS_INFO_TITLE = {
  awaiting: 'Ждём подписание документов',
  wrongCode: 'Клиент ввёл неправильный код',
  globalTimeout: 'Время ожидания истекло',
};

export const PROCESS_INFO_DESCRIPTION = {
  awaiting: '',
  wrongCode:
    'Попросите клиента ещё раз посмотреть, какой код пришёл в СМС, и ввести\nего правильно',
  globalTimeout:
    'Отправленный код устарел. Отправьте клиенту новый код и попросите\nназвать его вам',
};

export const INITIAL_DURATION = 60;
